export const getAwpComponent = async (innerComp: string) => {
  const componentImports = [
    () => import(`../../../mi-awp-components/src/organisms/${innerComp}/index`),
    () => import(`../../../mi-common-static-components/src/organisms/${innerComp}/index`),
    () => import(`../../../mi-designsystem-components/src/organisms/${innerComp}/index`),
  ];

  for (const importComponent of componentImports) {
    try {
      const module = await importComponent();
      const Component = module[innerComp];

      if (Component) {
        return { default: Component };
      }
    } catch (error) {
      // Try the next component folder before failing the lazy import.
    }
  }

  throw new Error(`AWP component "${innerComp}" was not found in AWP, common static, or designsystem organisms.`);
};
